/** Tunable game parameters (mirrors Processing `GameConfig`). */
export class GameConfig {
  initialEdgeCount = 3;
  maxMarbles = 100;
  addPoints = 50;
  subtractPoints = 25;
}
